export default function ClientProjects() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Projects Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
